import api from './axios';

// Login
export const login = async (email, password) => {
  const response = await api.post('/auth/login', { email, password });
  return response.data;
};

// Logout
export const logout = async () => {
  const response = await api.post('/auth/logout');
  return response.data;
};

// Get current user
export const getCurrentUser = async () => {
  const response = await api.get('/auth/me');
  return response.data;
};

// Change password
export const changePassword = async (oldPassword, newPassword) => {
  const response = await api.post('/auth/change-password', {
    old_password: oldPassword,
    new_password: newPassword
  });
  return response.data;
};

// Get profile
export const getProfile = async () => {
  const response = await api.get('/profile');
  return response.data;
};

// Update profile
export const updateProfile = async (data) => {
  const response = await api.put('/profile/update', data);
  return response.data;
};
